import React, { Component } from "react";
import { Tabs } from "antd";
import { connect } from "react-redux";
import ContributionActivityTable from "./Components/ContributionActivityTable";
import ContributionActivityCard from "./Components/ContributionActivityCard";
import { StyleLessButton } from "../../../../CommonComponents/commonStyles";
import { oneYearBackDate, todayDate } from "../../../../utils/commonUtil";
import { ContentProvider,Types, ContentMessage } from '../../../../CommonComponents/ContentMessages';  
import { Row, Col } from "antd";
import ContributionSearch from "./Components/ContributionSearch";
import moment from "moment";
import ContributionSearchMobile from "./Components/ContributionSearch/ContributionSearchMobile";
import {
  ContributionContentWrapper,
  ContributionActivityText,
  AccountIdWrapper,
  FundNameWrapper,
  ContributionActivityHeading,
  IconsPlaceNew,
  IconPadding,
  DataExportPrint,
  SelectTabsWrapper,
  FilterWrappered,
  FlexCenter,
  PrintExportBtn,
  FixedWidth,
  ActivityFixedWidth,
  FlexEnd,
  FilterButton,
  FilterArrow,
  StyledMenu, AccountSummary
} from "./styles";
import {FundSummaryContainer, FundSummaryContent, Label, Number} from "../../../Grants/Pages/GrantsActivity/style";
import { updateFilterData, fetchContributionActivityData } from "./actions";
import PageAccountSummary from "../../../../CommonComponents/PageSummary/PageAccountSummary/PageAccountSummary";
import BreadcrumbComponent from "../../../../CommonComponents/Breadcrumb/Breadcrumb";
import PrintComponents from "react-print-components";
import { getPrimaryAccount } from "../../../../utils/sessionUtil";
import {initiateTracking, recordError} from "../../../../utils/commonUtil";
import printIcon from "../../../../assets/icons/print.svg";
import Workbook from "react-excel-workbook";
import funnelIcon from "../../../../assets/icons/Funnel.png";
import exportIcon from "../../../../assets/icons/export.svg";
import PropTypes from 'prop-types';
import { CAMainPageState } from "./selectors";
import { resetContribution } from "../../../../Epics/Contributions/Pages/ContributionActivity/actions";
import { exportExcelTableData } from "../../../../services/apiServices";
import { isEmpty } from "lodash";

export class ContributionActivity extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      showModal: false,
      exportDataSource: this.props.contributionData || []
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    window.scrollTo(0, 0);
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(this.props.contributionData) !== JSON.stringify(nextProps.contributionData)) {
      this.setState({ exportDataSource: nextProps.contributionData})
    }
   }

  setWrapperRef(node) {
        this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ showModal: !this.state.showModal });
    }
  }

  componentWillMount() {
    let data = {};
    this.props.resetContribution();
    if (process.env.REACT_APP_NODE_ENV === "development") {
      data = {
        metaData: {
          method: "GET",
          page: "contributionActivity",
          url: {
            contributionActivity: `/contributionActivity/activity`
          }
        }
      };
    } else {
      data = {
        metaData: {
          method: "GET",
          page: "contributionActivity",
          url: {
            contributionActivity: `/donor-portal/api/contribution/${
              getPrimaryAccount().userId
              }/findByAccountIdStartDateAndEndDate?startDateStr=${oneYearBackDate()}&endDateStr=${todayDate()}`
          }
        }
      };
    }
    this.props.fetchContributionActivityData(data);
  }

  handleDropper = value => {
    let contributionsSorted = [];
    let filteredData = [];
    let mainData = this.props.loadMore? this.props.contributionData : this.props.contributionWholeData;
    let selectedStatus = null;
    if (this.props.timeFrameData && this.props.timeFrameData.dates?.length && value.length > 0) {
      mainData = this.props.timeFrameData.data;
    }
    let isCalculated = false;
    let statusData = [];
    if (mainData !== undefined) {
      let updatedData = mainData;
      if (value.length > 0) {
        value.map(status => {
          let filterData = [];
          filterData.push(
            updatedData.filter(data => {
              if (data.status === status) {
                return true;
              }
            })
          );
          if (filterData[0].length > 0) {
            filterData[0].map(data => filteredData.push(data));
          }
          statusData = filteredData;
        });
        selectedStatus = value;
      } else {
        if (this.props.timeFrameData && this.props.timeFrameData.dates?.length) {
          updatedData = this.props.contributionData;
          let datess = this.props.timeFrameData.dates;
          const date1 = moment(datess[0], "MM/DD/YYYY");
          const date2 = moment(datess[1], "MM/DD/YYYY");
          filteredData = updatedData.filter(x => {
            if (x.enteredDate !== "--") {
              if (moment(x.enteredDate, "MM/DD/YYYY") >= date1 && moment(x.enteredDate, "MM/DD/YYYY") <= date2) {
                return true;
              } else {
                return false;
              }
            }
          }
          );
          statusData = filteredData;
          isCalculated = true;
        } else {
          filteredData = this.props.contributionWholeData;
        }
      }
      contributionsSorted = filteredData;
      const { sortedInfo } = this.state;
      if(!isEmpty(sortedInfo)) {
        const { column } = sortedInfo;
        contributionsSorted = filteredData.slice().sort(column.sorter);
      }
      this.setState({ exportDataSource: contributionsSorted });
      this.props.updateFilterData({ filteredData, mode: "statusFilterData", data: statusData, status: selectedStatus, isCalculated });
    }
  };

  fundSummaryConfiguration = () => {
    let accountData = getPrimaryAccount();
    return [
      this.renderFundSummary({
        label: accountData.accountName,
        value: accountData.currentBalance
      })
    ];
  };

  renderFundSummary(obj) {
    return <PageAccountSummary label={obj.label} value={obj.value} />;
  }

  breadcrumbRoutes = () => {
    return [
      {
        routeName: "Home",
        path: "/"
      },
      {
        routeName: "Contributions",
        path: "/contributions"
      },
      {
        routeName: "Contribution Activity",
        path: ""
      }
    ];
  };

  handleFilter = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  analyticsTracking = (value) => {
    try {
      initiateTracking(value.toLowerCase(),'Contribution Activity', '' ,value);
    } catch (error) {
      recordError(error);
    }
  }

  exportData = (extra, sorter) => {
    this.setState({ exportDataSource: extra.currentDataSource, sortedInfo: sorter});
  }

  exportAllContribution = () => {
    const { exportDataSource } = this.state;
    this.analyticsTracking('Export');
    let filename = 'Contribution Activity';
    let url = `/donor-portal/api/contribution/${getPrimaryAccount().userId}/exportAllContributions`;
    return exportExcelTableData(url, exportDataSource, filename);
  }

  render() {
    const TabPane = Tabs.TabPane;
    let accountData = getPrimaryAccount();
    return (
      <ContentProvider
        types={[Types.PAGE_TITLE_DESCRIPTION]}
        pages={['Contribution Activity']}
      >
      <FixedWidth  className="Contribution_Activity">
        <BreadcrumbComponent role="navigation" breadcrumbRoutes={this.breadcrumbRoutes()} />
        <ContributionActivityHeading aria-level="1">
          <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page="Contribution Activity" property="field_page_title" defaultMessage="Contribution activity" />
        </ContributionActivityHeading>
        <FundSummaryContainer>
        <FundSummaryContent isNoMargin>
          <AccountSummary>
            <ActivityFixedWidth>
              <Label><FundNameWrapper>{accountData.accountName}</FundNameWrapper></Label>
            </ActivityFixedWidth>
            <Number><AccountIdWrapper>{accountData.accountNumber}</AccountIdWrapper></Number>
          </AccountSummary>
        </FundSummaryContent>
      </FundSummaryContainer>
        <ContributionContentWrapper role="definition">
          {this.props.drupalData && this.props.drupalData.field_page_title ? <div dangerouslySetInnerHTML={{ __html: this.props.drupalData.description__value }}></div> :
        'On this page, you will find all contribution activity for your account. Use this page to check contribution status, review contribution activity, and export or print any contribution related documents. You can search by status or time frame.{" "}'
    }
        </ContributionContentWrapper>
        <Row>
          <Col lg={24} md={24} xs={24}>
            <PrintExportBtn>
              <div>
                <IconsPlaceNew>
                  <FlexCenter>
                    <div>
                      <div className="row text-center">
                        <StyleLessButton>
                          <IconPadding data-test="icon-padding" id={"btnExport"} primary={true} onClick={() => this.exportAllContribution()}>
                            <img src={exportIcon} alt="exportIcon"/>
                            <DataExportPrint>EXPORT</DataExportPrint>
                          </IconPadding>
                        </StyleLessButton>
                      </div>
                    </div>
                    <div>
                      <PrintComponents
                        className="i_print"
                        trigger={
                          <StyleLessButton>
                            <IconPadding data-test="icon-padding-2"  id={"btnPrint"}  className="ml2" onClick={() => this.analyticsTracking('Print')}>
                              <img src={printIcon} alt="printIcon"/>
                              <DataExportPrint>PRINT</DataExportPrint>
                            </IconPadding>
                          </StyleLessButton>
                        }
                      >
                        <div>
                            <ContributionActivityTable print={true} />
                        </div>
                      </PrintComponents>
                    </div>
                  </FlexCenter>
                </IconsPlaceNew>
              </div>
            </PrintExportBtn>
          </Col>
          <Col>
            <Row>
            {window.screen.availWidth > 768 ?
              <Col lg={24} md={0} sm={0} xs={0}>
                <SelectTabsWrapper>
                  <Tabs hideAdd type="card">
                    <TabPane tab="All Contributions" key="1" id="tbAllContributions">
                      <ContributionSearch handleDropper={this.handleDropper} />
                      <ContributionActivityTable exportData={this.exportData}/>
                    </TabPane>
                  </Tabs>
                </SelectTabsWrapper>
                <ContributionActivityText>
                * Entered Date is the date information was entered into the Vanguard Charitable database via the website user or staff member.
                <br />
                ** Received Date is the date Vanguard Charitable received the assets.
                </ContributionActivityText>
              </Col>
              :
              <Col lg={0} md={24} sm={24} xs={24}>
                <SelectTabsWrapper>
                  <Tabs type="card">
                    <TabPane tab="All Contributions" key="1" id="tbAllContributionsMob">
                      <FlexEnd>
                        <FilterButton data-test="Filter-Button"
                          onClick={() => this.handleFilter()}
                          onBlur={() => this.handleFilter()}
                          id={"btnFilter"}
                        >
                          Filter&nbsp;
                          <img src={funnelIcon} alt="filter" />
                        </FilterButton>
                      </FlexEnd>
                      {this.state.showModal ? (
                        <div ref={this.setWrapperRef} className="block">
                          <FilterArrow />
                          <FilterWrappered>
                            <StyledMenu>
                              <ContributionSearchMobile
                                handleDropper={this.handleDropper}
                              />
                            </StyledMenu>
                          </FilterWrappered>
                        </div>
                      ) : (
                          <div style={{ display: "none" }}>
                            <FilterArrow />
                            <FilterWrappered>
                              <StyledMenu>
                                <ContributionSearchMobile
                                  handleDropper={this.handleDropper}
                                />
                              </StyledMenu>
                            </FilterWrappered>
                          </div>
                        )}
                      <ContributionActivityCard />
                      <ContributionActivityText>
                        * The Entered date is the date information was entered
                        into the Vanguard Charitable database by a website user
                        or staff member.
                        <br />
                        ** The Received date is the date Vanguard Charitable
                        received the donated assets.
                      </ContributionActivityText>
                    </TabPane>
                  </Tabs>
                </SelectTabsWrapper>
              </Col>
            }
            </Row>
          </Col>
        </Row>
      </FixedWidth>
      </ContentProvider>
    );
  }
}

ContributionActivity.propTypes = {
  contributionData: PropTypes.array,
  statusFilterData: PropTypes.array,
  timeFrameData: PropTypes.array,
  drupalData: PropTypes.object,
  updateFilterData: PropTypes.func,
  fetchContributionActivityData: PropTypes.func
}

const mapStateToProps = state => ({
  ...CAMainPageState(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  updateFilterData: data => dispatch(updateFilterData(data)),
  fetchContributionActivityData: data =>
    dispatch(fetchContributionActivityData(data)),
  resetContribution: () => dispatch(resetContribution())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContributionActivity);